import BaseNoEquipmentCard from 'components/cards/BaseNoEquipmentCard';

import useRoles from 'hooks/useRoles';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const NoAircraftCard: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { canManageEquipment } = useRoles();
    const { MESSAGE_USER, TITLE } = useTranslation();

    const message = !canManageEquipment && MESSAGE_USER;

    return <BaseNoEquipmentCard message={message} testId={testId} title={TITLE} />;
};

export default NoAircraftCard;
